import React, { useEffect, useState } from 'react';
import { CustomAutoCompleteField } from '../../commons/CustomAutoCompleteField';
import { CustomFormikNumberField } from '../../commons/CustomFormikNumberField';
import { awsRegionLabels } from '../../commons/utils/AWSRegion';
import { TextWrapper, Wrapper } from './ConnectForm.Styles';
import { getInstanceARNs } from '../../../api';
export var ConnectForm = function (_a) {
    var awsRegions = _a.awsRegions, awsRegion = _a.awsRegion;
    var _b = useState([]), arnInstance = _b[0], setArnInstance = _b[1];
    var _c = useState([]), connectInstances = _c[0], setConnectInstances = _c[1];
    useEffect(function () {
        if (!(awsRegion === null || awsRegion === void 0 ? void 0 : awsRegion.length))
            return;
        getInstanceARNs(awsRegion).then(function (res) {
            setConnectInstances(res.data);
        });
    }, [awsRegion]);
    return (React.createElement(Wrapper, null,
        React.createElement(CustomAutoCompleteField, { options: awsRegions.map(function (region) { return ({
                label: awsRegionLabels[region]
                    ? awsRegionLabels[region] + " (" + region + ")"
                    : region,
                value: region
            }); }), name: 'awsRegion', label: 'AWS Region', placeholder: 'Please Select' }),
        React.createElement(TextWrapper, null,
            React.createElement(CustomAutoCompleteField, { options: connectInstances.map(function (connectInstance) { return ({
                    label: connectInstance.InstanceAlias + " (" + connectInstance.Arn + ")",
                    value: connectInstance.Arn
                }); }), name: 'instanceArn', label: 'Instance ARN', placeholder: 'Please Select' }),
            React.createElement(CustomFormikNumberField, { name: 'connectProjectCPS', label: 'Connect Project CPS', min: 1, max: 1000 }))));
};
ConnectForm.defaultProps = {};
//# sourceMappingURL=ConnectForm.js.map